import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export interface AvailableYearsResponse {
  years: number[];
}

export const useAvailableYears = () => {
  return useQuery({
    queryKey: ['useAvailableYears'],
    queryFn: () =>
      axios
        .get<AvailableYearsResponse>(`${envApiUrl}/years/available`, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => response.data),
  });
};
